import * as React from 'react';
import { styled } from '@mui/material/styles';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Collapse from '@mui/material/Collapse';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { red } from '@mui/material/colors';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Rating from '@mui/material/Rating';
import { Badge, Divider } from '@mui/material';
import LinkedInIcon from '@mui/icons-material/LinkedIn';

const SmallAvatar = styled(Avatar)(({ theme }) => ({
  width: 22,
  height: 22,
  border: `2px solid ${theme.palette.background.paper}`,
}));

const ExpandMore = styled((props) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
  marginLeft: 'auto',
  transition: theme.transitions.create('transform', {
    duration: theme.transitions.duration.shortest,
  }),
}));

export default function Review(props) {
  const [expanded, setExpanded] = React.useState(false);
  const {isSmallScreen, name, url , link, designation, content, company} = props;
  const [clicked, setClicked] = React.useState(false);
  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  const handleClick = () => {
    window.open(link);
  };

  return (
    <div style={{width:isSmallScreen ? "100%" :"70%", marginLeft: isSmallScreen? "0px" :"auto", marginBottom: "25px", cursor:"pointer", padding: "0 10px"}}>
      <div style={{width: "100%", display:"flex"}} onClick={handleClick}>
        <Badge
          overlap="circular"
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          style={{ margin: "auto"}}
          badgeContent={
            <SmallAvatar alt={name} src={"https://images.rawpixel.com/image_png_social_square/czNmcy1wcml2YXRlL3Jhd3BpeGVsX2ltYWdlcy93ZWJzaXRlX2NvbnRlbnQvbHIvdjk4Mi1kMy0xMC5wbmc.png"} style={{ margin: "auto", display:"block" }}/>
          }
        >
          <Avatar alt={name} src={url} style={{ height: "8rem", width: "8rem", margin: "auto", display:"block" }} />
        </Badge>
      </div>
      <div onClick={handleClick} className='only-heading' style={{fontSize:isSmallScreen? "1.2rem": "1.75rem", margin : "1rem auto 0 auto", textAlign: "center"}}>{name}</div>
      <div style={{textAlign: "center",color: "#666666", marginTop: "5px"}}>{designation}</div>
      <div style={{textAlign: "center",color: "black", marginTop: "5px", fontWeight: "600"}}>{company}</div>
      <Divider style={{margin: "20px 30% 20px 30%" , backgroundColor: "#0075c9"}}/>
      {
        clicked
          ?
          <div style={{textAlign: "center", color: "#666666", padding: isSmallScreen && "0 5% 0 5%" }}>
            {content}
          </div>
          :
          <div style={{ textAlign: "center", color: "#666666", padding: isSmallScreen && "0 5% 0 5%" }}>
            {content.substring(0, 180) + "..."}
          </div>
      }
      <div style={{textAlign: "center",color: "blue", paddingTop: "10px"}} onClick={(e) => setClicked(!clicked)}>{
        clicked ?
        "Read Less"
        :
        "Read More"
      }</div>
    </div>
  );
}